module.exports = __webpack_public_path__ + "static/media/Bar01.0a4d536e.jpg";